import BrizIcon from './component'

export default BrizIcon
